import React from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

// Окно лимита бесплатной версии: показывается после 3 сгенерированных фото
// и при попытке сгенерировать недостающие фото блюд сверх лимита.
const GenerationLimitDialog = ({ open, onClose }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const goToSubscription = () => {
    onClose?.()
    navigate("/subscription")
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("Free plan limit reached")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("Generation limit message")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>{t("Upload photo manually")}</Button>
        <Button variant="contained" onClick={goToSubscription}>
          {t("Upgrade plan")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default GenerationLimitDialog
